<template>
<div class="wrapBalloon" :class="{balloonIn: this.$store.state.selectedVal != null && this.$store.state.selectedVal != false}">
<div class="balloon">
  <span class="textBalloon">{{title}}</span>
</div>
</div>  
</template>

<script>
  export default {
    name: 'Balloon',
    props: ['title']
  }
</script>
  
<style lang="less">
@import "../../styles/global.less";
.wrapBalloon {
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  bottom: calc(~"0px - 300px");

  transition: bottom 2s;
}

.balloonIn {
  bottom: 25%;
}

.balloon {
  display:inline-block;
   width:120px;
  height:145px;
  background:hsl(215,50%,65%);
  border-radius:80%;
  position:relative;
  box-shadow:inset -10px -10px 0 rgba(0,0,0,0.07);
  margin:20px 30px;
  transition:transform 0.5s ease;
  z-index:10;
  animation:balloons 4s ease-in-out infinite;
  transform-origin:bottom center;
}

.textBalloon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
  pointer-events: none;
}

@keyframes balloons {
  0%,100%{ transform:translateY(0) rotate(-4deg); }
  50%{ transform:translateY(-25px) rotate(4deg); }
}


.balloon:before {
  content:"▲";
  font-size:20px;
  color:hsl(215,30%,50%);
  display:block;
  text-align:center;
  width:100%;
  position:absolute;
  bottom:-12px;
  z-index:-100;
}

.balloon:after {
 display:inline-block; top:153px;
  position:absolute;
  height:250px;
  width:1px;
  left: 47.5%;
  margin-top: -4px;
  content:"";
  background:rgba(0,0,0,0.2); 
}

@media screen and (max-width: @breakpoint1) {
  .balloon {
    width:60px;
    height:75px;
  }

  .balloon:after {
    height: 170px;
    margin-top: -86px;
  }

  .balloon:before {
  content:"▲";
  font-size:12px;
  color:hsl(215,30%,50%);
  display:block;
  text-align:center;
  width:100%;
  position:absolute;
  bottom:-9px;
  z-index:-100;
  }


  .balloon:after {
      display: inline-block;
      top: 84px;
      position: absolute;
      height: 250px;
      width: 1px;
      left: 46.5%;
      margin-top: -4px;
      content: "";
      background: rgba(0, 0, 0, 0.2);
  }

}

</style>


// WEBPACK FOOTER //
// src/components/library/balloon.vue